import { Controller, useForm } from 'react-hook-form'
import moment from 'moment'

import { Box, Chip, Grid, InputAdornment, TextField } from '@material-ui/core'
import { DatePicker } from '@material-ui/pickers'

import { Card } from 'components'
import { DelinquencyTable } from '..'

import * as service from 'service'
import helpers from 'helpers'
import constants from 'constants/index'
import PropTypes from 'prop-types'

import { useSnackbar } from 'hooks'

import schema from './schema'
import theme from 'theme'

const SolicitationStep = ({ churn, setLoading, handleNextStep, show }) => {
  const snackbar = useSnackbar()

  const { control, errors, handleSubmit } = useForm({
    validationSchema: schema,
    defaultValues: {
      ticketId: churn?.ticketId ?? '',
      document:
        helpers.formatters.cnpjAndCpfMask(churn?.preRegistration?.document) ||
        '',
      company: churn?.preRegistration?.name || '',
      segment: churn?.preRegistration?.plan?.segment?.name || '',
      companySize: churn?.preRegistration?.plan?.code || '',
      contractStartDate: moment(churn?.paymentContract?.startDate) || '',
      contractEndDate: churn?.paymentContract?.endDate
        ? moment(churn?.paymentContract?.endDate)
        : null,
      ticketDate: churn?.ticketDate || null,
      mrr: helpers.formatters.currencyInput(churn?.paymentContract?.price || 0),
      seller: churn?.preRegistration?.seller?.name || '',
      responsible: helpers.churns.author(churn, false),
      contractIdentifier: churn?.paymentContract?.contractIdentifier || '',
      origin: churn?.origin ? constants.churn.ORIGINS[churn?.origin] : '',
    },
  })

  const onSubmit = async (data) => {
    setLoading(true)

    const params = {
      ticketId: data.ticketId,
      ticketDate: moment(data.ticketDate).format('YYYY-MM-DD'),
    }

    try {
      await service.dponet.churns.update({
        churnId: churn.id,
        params,
      })

      snackbar.open({
        message: `Churn atualizado com sucesso!`,
        variant: 'success',
      })
      handleNextStep()
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Erro ao salvar as informações',
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Box
      component="form"
      id={constants.churn.CHURN_STEPPER_SOLICITATION_ID_FORM}
      onSubmit={handleSubmit(onSubmit)}
      display="flex"
      flexDirection="column"
      gridGap={theme.spacing(4)}
    >
      <Card
        title="Informações da empresa"
        paddingCard={0}
        actionButton={
          <Chip
            align="center"
            size="small"
            label={constants.churn.STATUS_LABEL_TRANSLATION[churn?.status]}
            style={{
              backgroundColor: constants.churn.CHIP_STATUS_COLOR[churn?.status],
              color: '#FFFFFF',
            }}
          />
        }
      >
        <Grid container spacing={2}>
          {constants.churn.COMPANY_INFO_CONTROL_ITEMS.map((item, index) => (
            <Grid key={index} item xs={12} md={item?.gridMd}>
              {item?.component === 'datePicker' ? (
                <Controller
                  as={
                    <DatePicker
                      format="DD/MM/yyyy"
                      label={item?.label}
                      onChange={(newValue) => ({
                        value: newValue,
                      })}
                      error={!!errors?.[item?.controlName]}
                      helperText={<>{errors?.[item?.controlName]?.message}</>}
                      InputProps={{ inputMode: item?.mode }}
                      fullWidth
                      disabled={show || item?.controlName !== 'ticketDate'}
                    />
                  }
                  control={control}
                  name={item?.controlName}
                  mode="onChange"
                />
              ) : (
                <Controller
                  as={
                    <TextField
                      type={item?.inputMode}
                      color="primary"
                      variant="outlined"
                      label={item?.label}
                      error={!!errors?.[item?.controlName]}
                      helperText={<>{errors?.[item?.controlName]?.message}</>}
                      fullWidth
                      disabled={show || item?.controlName !== 'ticketId'}
                      InputProps={{
                        ...(item?.controlName === 'mrr' && {
                          startAdornment: (
                            <InputAdornment position="start">R$</InputAdornment>
                          ),
                        }),
                      }}
                    />
                  }
                  control={control}
                  name={item?.controlName}
                />
              )}
            </Grid>
          ))}
        </Grid>
      </Card>
      <DelinquencyTable churnId={churn.id} />
    </Box>
  )
}

SolicitationStep.propTypes = {
  churn: PropTypes.object,
  setLoading: PropTypes.func,
  handleNextStep: PropTypes.func,
  show: PropTypes.bool,
}

export default SolicitationStep
